import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { Form, FormGroup, Input, Label } from "reactstrap";
import { Btn, H4, H6, Image, P } from "../AbstractElements";
import { AuthSignIn, CreateAccount, DontHaveAccount, EmailAddressLogIn, EnterYourEmailPasswordToLogin, Href, OrSignInWith, PasswordLogIn, RememberPassword, SignInToAccount } from "../Constant";
import { dynamicImage } from "../Service/DynamicImage";
import SocialApp from "./SocialApp";

const AuthLoginFrom = () => {
  const [show, setShow] = useState(false);
  const [email, setEmail] = useState("test123@gmail.com");
  const [password, setPassword] = useState("Test@123");
  const navigate = useNavigate();

  const SimpleLoginHandle = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    if (email === "test123@gmail.com" && password === "Test@123") {
      localStorage.setItem("login", JSON.stringify(true));
      toast.success("Login Success...!");
      navigate(`${process.env.PUBLIC_URL}/dashboard/default`);
    } else {
      toast.error("Please Enter valid email or password...!");
    }
  };

  return (
    <div>
      <div>
        <Link className="logo text-center" to={Href}>
          <Image className="img-fluid for-light" src={dynamicImage("logo/logo_dark.png")} alt="looginpage" />
          <Image className="img-fluid for-dark" src={dynamicImage("logo/logo.png")} alt="looginpage" />
        </Link>
      </div>
      <div className="login-main">
        <Form className="theme-form" onSubmit={(e)=>SimpleLoginHandle(e)}>
          <H4>{SignInToAccount}</H4>
          <P>{EnterYourEmailPasswordToLogin}</P>
          <FormGroup>
            <Label className="col-form-label">{EmailAddressLogIn}</Label>
            <Input type="text" defaultValue={email} onChange={(event) => setEmail(event.target.value)} />
          </FormGroup>
          <FormGroup>
            <Label className="col-form-label">{PasswordLogIn}</Label>
            <div className="form-input position-relative">
              <Input type={show ? "text" : "password"} defaultValue={password} onChange={(event) => setPassword(event.target.value)} />
              <div className="show-hide" onClick={() => setShow(!show)}>
                <span className="show"> </span>
              </div>
            </div>
          </FormGroup>
          <div className="form-group mb-0">
            <div className="checkbox p-0">
              <Input id="checkbox1" type="checkbox" />
              <Label className="text-muted" htmlFor="checkbox1">{RememberPassword}</Label>
            </div>
            <div className="text-end mt-3">
              <Btn color="primary" className="btn-block w-100">{AuthSignIn}</Btn>
            </div>
          </div>
          <H6 className="text-muted mt-4 or">{OrSignInWith}</H6>
          <SocialApp />
          <P className="mt-4 mb-0 text-center">{DontHaveAccount}
            <Link className="ms-2" to={Href}>{CreateAccount}</Link>
          </P>
        </Form>
      </div>
    </div>
  );
};

export default AuthLoginFrom;
